import "../../../assets/styles/admin/opd.scss";
// import Input from "../../../components/textfield/input";
// import Select from "../../../components/select/selectField";
import CheckboxText from "../../../components/textfield/checkbox";
// import Button from "../../../components/button/Button";
import { useEffect, useState } from "react";
import HeaderBar from "../../../components/header/headerBar";
import { useHistory, useLocation, useParams } from "react-router-dom";
import {
  Input,
  Select,
  Button,
  Row,
  Col,
  Form,
  Checkbox,
  InputNumber,
} from "antd";
import { Icon } from "@iconify/react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { getFileHostUrl } from "../../../helpers/functions";
import ModalMessage from "../../../components/antd/modalMessage";
import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd/dist/antd.css";
import "antd-country-phone-input/dist/index.css";
interface ParamTypes {
  id?: string;
}

const EmergencyContact = () => {
  const navigate = useHistory();
  let [formList] = Form.useForm();
  const dispatch = useDispatch();
  const { id } = useParams<ParamTypes>();
  const { opd } = useSelector((state: any) => state);

  const CheckboxGroup = Checkbox.Group;

  const [route, setRoute] = useState("");
  const [CongenitalDisease, setCongenitalDisease] = useState<string>("");
  const [TreatMent, setTreatMent] = useState<string>("");

  const [OtherDer, setOtherDer] = useState<any>([]);
  const [OtherAesthetic, setOtherAesthtic] = useState<any>([]);
  const [OtherCosmetic, setOtherCosmetic] = useState<any>([]);
  const [OtherHair, setOtherHair] = useState<any>([]);
  const [OtherBody, setOtherBody] = useState<any>([]);

  const [nameErrors, setNameErrors] = useState<boolean>(false);
  const [mobileErrors, setMoBileErrors] = useState<boolean>(false);
  const [sureryErrors, setSureryErrors] = useState<boolean>(false);
  const [underLyingErrors, setUnderLyingErrors] = useState<boolean>(false);

  const [optHowDidYou, setOptHowDidYou] = useState<any>([]);
  const [optAesthetic, setOptAesthetic] = useState<any>([]);
  const [optCosmetic, setOptCosmetic] = useState<any>([]);
  const [optHair, setOptHair] = useState<any>([]);
  const [optBody, setOptBody] = useState<any>([]);
  const [optRelationships, setOptRelationships] = useState<any>([]);

  const [chackOther, setChackOther] = useState<any>([]);
  const [other, setOther] = useState<any>([]);
  const [optTitles, setOptTitles] = useState<any>([]);

  const [showModal, setShoeModal] = useState<boolean>(false);
  const [messageId, setMessageId] = useState<any>([]);
  const [value1, setValue1] = useState<CountryPhoneInputValue>({
    short: "TH",
  });
  const [valuePhone1, setPhoneValue1] = useState<any>({});

  async function onSubmit(values: any) {
    let dataDer = [];
    let dataAesthetic = [];
    let dataCosmetic = [];
    let dataHair = [];
    let dataBody = [];

    if (values["hearAboutDermasters"]) {
      dataDer = values["hearAboutDermasters"].map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherDer"]) {
      dataDer.push({ _id: chackOther.otherDer, other: values["otherDer"] });
    }

    if (values["aestheticCenters"]) {
      dataAesthetic = values["aestheticCenters"]?.map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherAesthetic"]) {
      dataAesthetic.push({
        _id: chackOther.otherAesthetic,
        other: values["otherAesthetic"],
      });
    }

    if (values["cosmeticSurgeryCenters"]) {
      dataCosmetic = values["cosmeticSurgeryCenters"]?.map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherCosmetic"]) {
      dataCosmetic.push({
        _id: chackOther.otherCosmetic,
        other: values["otherCosmetic"],
      });
    }

    if (values["hairCenters"]) {
      dataHair = values["hairCenters"]?.map((item: any) => ({ _id: item }));
    }
    if (values["otherHair"]) {
      dataHair.push({ _id: chackOther.otherHair, other: values["otherHair"] });
    }

    if (values["bodyCenters"]) {
      dataBody = values["bodyCenters"]?.map((item: any) => ({ _id: item }));
    }
    if (values["otherBody"]) {
      dataBody.push({ _id: chackOther.otherBody, other: values["otherBody"] });
    }
    console.log(opd?.date);

    if (opd?.date) {
      let data = {
        ...opd,
        agency: opd?.agencySearch,
        agencyMember: opd?.agency,
        sale: opd?.personal,
        prefix: opd?.title,
        passportId: opd?.passportID ? opd?.passportID : "",
        address: {
          addressNumber: opd?.addressNumber,
          buildingName: opd?.buildingName ? opd?.buildingName : "",
          moo: opd?.moo ? opd?.moo : "",
          soi: opd?.soi ? opd?.soi : "",
          road: opd?.road ? opd?.road : "",
          country: opd?.country,
          state: opd?.state,
          city: opd?.city,
          subCity: opd?.subCity,
          postalCode: opd?.postalCode,
        },
        allergyHistory: values["allergyHistory"],
        underlyingDisease: values["underlyingDisease"],
        whereGotTreatment: values["whereGotTreatment"],
        emergencyContact: {
          prefix: values["prefix"],
          firstName: values["firstName"],
          lastName: values["lastName"],
          relationship: values["relationship"],
          phoneNumber: valuePhone1?.phone ? valuePhone1 : {},
        },
        hearAboutDermasters: dataDer,
        aestheticCenters: dataAesthetic,
        cosmeticSurgeryCenters: dataCosmetic,
        hairCenters: dataHair,
        bodyCenters: dataBody,
      };

      if (!opd?.isSameAddressIDCard) {
        let dataV2 = {
          ...data,
          addressCurrent: {
            addressNumber: opd?.addressNumberPresent,
            buildingName: opd?.buildingNamePresent ? opd?.buildingName : "",
            moo: opd?.mooPresent ? opd?.mooPresent : "",
            soi: opd?.soiPresent ? opd?.soiPresent : "",
            road: opd?.roadPresent ? opd?.roadPresent : "",
            country: opd?.countryPresent,
            state: opd?.statePresent,
            city: opd?.cityPresent,
            subCity: opd?.subCityPresent,
            postalCode: opd?.postalCodePresent,
          },
        };

        setSaveData(dataV2);
      } else {
        setSaveData(data);
      }
    }
  }
  const checkValue1 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };

  const setSaveData = async (data: any) => {
    console.log(data);

    await axios.post(`/member-opd`, data).then((res) => {
      setMessageId(res?.data._id);
      if (opd?.uploadImage) {
        uploadProfile(res?.data._id, opd?.uploadImage);
      } else {
        setShoeModal(!showModal);
      }
    });
  };

  const uploadProfile = async (id: any, upload: any) => {
    try {
      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };

      fmData.append("file", upload?.fileList[0]?.originFileObj);

      await axios.post(`/member-opd/upload-profile/${id}`, fmData, config);

      dispatch({
        type: "CREATE_OPD",
        data: {},
      });

      setShoeModal(!showModal);

      // navigate.push(`/opd/list/${id}`);
    } catch (error) {}
  };

  const location = useLocation();

  const options = [
    { label: "Apple", value: "Apple" },
    { label: "Pear", value: "Pear" },
    { label: "Orange", value: "Orange" },
  ];

  const getPrefixes = async () => {
    const titleName = await axios.get(`/prefixes`);
    const title = [];
    for (let i = 0; i < titleName?.data?.data.length; i++) {
      title.push(
        <Select.Option
          value={titleName?.data?.data[i]?._id}
          key={titleName?.data?.data[i]?._id}
        >
          {titleName?.data?.data[i]?.name}
        </Select.Option>
      );
    }
    setOptTitles(title);
  };

  const getHowDidYou = async () => {
    await axios.get(`/hear-about-dermasters`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        setOtherDer({ label: other?.name, value: other?._id });
      }

      setOptHowDidYou(code);
    });
  };

  const getAestheticCenter = async () => {
    await axios.get(`/aesthetic-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        setOtherAesthtic({ label: other?.name, value: other?._id });
      }
      setOptAesthetic(code);
    });
  };

  const getCosmeticSurgeryCenter = async () => {
    await axios.get(`/cosmetic-surgery-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        setOtherCosmetic({ label: other?.name, value: other?._id });
      }
      setOptCosmetic(code);
    });
  };

  const getHairCenter = async () => {
    await axios.get(`/hair-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        setOtherHair({ label: other?.name, value: other?._id });
      }
      setOptHair(code);
    });
  };

  const getBodyCente = async () => {
    await axios.get(`/body-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        setOtherBody({ label: other?.name, value: other?._id });
      }
      setOptBody(code);
    });
  };

  const getRelationships = async () => {
    await axios.get(`/relationships`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptRelationships(code);
    });
  };
  // const onKeydownCheck = (eveb: KeyboardEvent) => {
  //   console.log("e event", eveb.which);
  //   if (eveb.which !== 8) {
  //     eveb.preventDefault();
  //     // message.error("Please Input Max 10 ");
  //   }
  // };
  useEffect(() => {
    window.scrollTo(0, 0);
    setRoute(location.pathname);
    getHowDidYou();
    getAestheticCenter();
    getCosmeticSurgeryCenter();
    getHairCenter();
    getBodyCente();
    getPrefixes();
    getRelationships();
  }, []);

  return (
    <div>
      <HeaderBar btnBack={true} title="Emergency Contact Name" />
      <div style={{ padding: "0px 80px" }}>
        <Form form={formList} onFinish={onSubmit}>
          <div className="page allergypage-page">
            <div className="title-header">
              <h4>Allergy History and Underlying Disease</h4>
            </div>
            <div className="allergy-history">
              <p>Allergy Surery Center (ประวัติแพ้ยา/เครื่องสำอาง)*</p>
              <Form.Item
                name="allergyHistory"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  className={`${sureryErrors ? "ValidateForm" : ""}`}
                  placeholder="Allergy Surery Center (ประวัติแพ้ยา/เครื่องสำอาง)*"
                />
              </Form.Item>
              <p>Underlying disease (โรคประจำตัว)*</p>
              <Form.Item
                name="underlyingDisease"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  className={`disease ${
                    underLyingErrors ? "ValidateForm" : ""
                  }`}
                  style={{ marginTop: "14px" }}
                  placeholder="Underlying disease (โรคประจำตัว)*"
                  type="text"
                  onChange={(e) => {
                    // setCongenitalDisease(e.target.value);
                    // setUnderLyingErrors(!e.target.value ? true : false);
                  }}
                />
              </Form.Item>
            </div>
            <div className="allergy-history-p">
              <p>Where have got treatment? (เคยรักษาที่ไหนมาก่อน)</p>
              <Form.Item name="whereGotTreatment">
                <Input
                  placeholder="Where have got treatment? (เคยรักษาที่ไหนมาก่อน)"
                  type="text"
                />
              </Form.Item>
            </div>
            <div className="title-header">
              <h4 style={{ margin: "40px 0 0" }}>Emergency Contact</h4>
            </div>

            <Row
              gutter={[16, 16]}
              className="emergency-contact"
              style={{ marginTop: "30px" }}
            >
              <Col span={6} style={{ marginTop: "4px" }}>
                <Form.Item
                  name="prefix"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    placeholder="คำนำหน้าชื่อ / TITLE"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {optTitles}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="firstName"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input
                    className={`${nameErrors ? "ValidateForm" : ""}`}
                    placeholder="ชื่อ / NAME*"
                    type="text"
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name="lastName"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input placeholder="นามสกุล / SURNAME" type="text" />
                </Form.Item>
              </Col>
              <Col span={6} style={{ marginTop: "4px" }}>
                <Form.Item
                  name="relationship"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    placeholder="RELATIONSHIP"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  >
                    {optRelationships}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="emergency-contact">
              <Col span={12}>
                <Form.Item
                  name="phoneNumber"
                  className="select-countrycode-create"

                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "กรุณากรอกข้อมูล!",
                  //   },
                  // ]}
                >
                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      type="number"
                      value={value1}
                      onChange={(v: any) => {
                        setValue1(v);
                        checkValue1(v);
                      }}
                    />
                  </ConfigProvider>
                  {/* <Input
                    type="number"
                    className={`${mobileErrors ? "ValidateForm" : ""}`}
                    placeholder="MOBILE NO.*"
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  /> */}
                </Form.Item>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5 style={{ marginTop: "unset" }}>
                How did you hear about Dermaster? (รู้จัก Dermaster จากที่ไหน?)
              </h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "18px" }}
              className="hear-about-der"
            >
              <Col span={24}>
                <Form.Item name="hearAboutDermasters">
                  <CheckboxGroup options={optHowDidYou} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    onChange={(e) => {
                      setChackOther({
                        ...chackOther,
                        otherDer: OtherDer.value,
                      });
                      setOther({ ...other, otherDer: e.target.checked });
                      formList.setFieldsValue({
                        otherDer: null,
                      });
                    }}
                  >
                    {OtherDer.label}
                  </Checkbox>
                  <Form.Item
                    name="otherDer"
                    rules={[
                      {
                        required: other?.otherDer ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={other?.otherDer ? false : true} />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Aesthetic Center (แผนกผิวพรรณและความงาม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="aesthetic-centers"
            >
              <Col span={24}>
                <Form.Item name="aestheticCenters">
                  <CheckboxGroup options={optAesthetic} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    onChange={(e) => {
                      setChackOther({
                        ...chackOther,
                        otherAesthetic: OtherAesthetic.value,
                      });
                      setOther({ ...other, otherAesthetic: e.target.checked });
                      formList.setFieldsValue({
                        otherAesthetic: null,
                      });
                    }}
                  >
                    {OtherAesthetic.label}
                  </Checkbox>
                  <Form.Item
                    name="otherAesthetic"
                    rules={[
                      {
                        required: other?.otherAesthetic ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={other?.otherAesthetic ? false : true} />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Cosmetic Surgery Center (แผนกศัลยกรรมความงาม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="cosmetic-surgery-centers"
            >
              <Col span={24}>
                <Form.Item name="cosmeticSurgeryCenters">
                  <CheckboxGroup options={optCosmetic} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    onChange={(e) => {
                      setChackOther({
                        ...chackOther,
                        otherCosmetic: OtherCosmetic.value,
                      });
                      setOther({ ...other, otherCosmetic: e.target.checked });
                      formList.setFieldsValue({
                        otherCosmetic: null,
                      });
                    }}
                  >
                    {OtherCosmetic.label}
                  </Checkbox>
                  <Form.Item
                    name="otherCosmetic"
                    rules={[
                      {
                        required: other?.otherCosmetic ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={other?.otherCosmetic ? false : true} />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Hair Center (แผนกผม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="hair-centers"
            >
              <Col span={24}>
                <Form.Item name="hairCenters">
                  <CheckboxGroup options={optHair} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    onChange={(e) => {
                      setChackOther({
                        ...chackOther,
                        otherHair: OtherHair.value,
                      });
                      setOther({ ...other, otherHair: e.target.checked });
                      formList.setFieldsValue({
                        otherHair: null,
                      });
                    }}
                  >
                    {OtherHair.label}
                  </Checkbox>
                  <Form.Item
                    name="otherHair"
                    rules={[
                      {
                        required: other?.otherHair ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={other?.otherHair ? false : true} />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Body Center (แผนกรูปร่างและสัดส่วน)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="body-centers"
            >
              <Col span={24}>
                <Form.Item name="bodyCenters">
                  <CheckboxGroup options={optBody} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Checkbox
                    onChange={(e) => {
                      setChackOther({
                        ...chackOther,
                        otherBody: OtherBody.value,
                      });
                      setOther({ ...other, otherBody: e.target.checked });
                      formList.setFieldsValue({
                        otherBody: null,
                      });
                    }}
                  >
                    {OtherBody.label}
                  </Checkbox>
                  <Form.Item
                    name="otherBody"
                    rules={[
                      {
                        required: other?.otherBody ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={other?.otherBody ? false : true} />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>
          <div className="btn-confirm button-save">
            <Button type="primary" htmlType="submit">
              บันทึกข้อมูล/SAVE
            </Button>
            <ModalMessage
              show={showModal}
              title="บันทึกผู้ใช้งานเรียบร้อยแล้ว"
              subTitle="User saved successfully."
              path={`/opd/list/${messageId}`}
              status={true}
            />
          </div>
        </Form>
      </div>
    </div>
  );
};
export default EmergencyContact;
